import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import { validatePrice } from '@/utils/category';
import { useTranslations } from 'next-intl';

const Pricing = ({ price: priceWithTax, showOfferLabel = true }) => {
  const t = useTranslations('product');
  const price = validatePrice(priceWithTax);
  return (
    <div className='flex items-center justify-between gap-5'>
      <h2 className='flex items-center gap-1 text-2xl leading-10.5 font-bold text-red-600'>
        {handlePriceByComma(
          !showOfferLabel
            ? price?.originalPrice
            : price?.specialPrice || price?.originalPrice
        )}{' '}
        <CurrencyIcon className='size-4 md:size-4.5' />
      </h2>
      {price?.specialPrice && showOfferLabel ? (
        <h2 className='mt-2 flex items-center gap-1 text-sm font-semibold text-[#6B7280] line-through'>
          {handlePriceByComma(price?.originalPrice)}{' '}
          <CurrencyIcon className='size-3' />
        </h2>
      ) : null}
      {price?.specialPrice && showOfferLabel ? (
        <div className='flex max-h-7 min-h-7 items-center justify-center gap-2 rounded-full bg-[#fee2e2] px-3 py-2 text-[#991b1b] shadow-sm max-sm:ms-auto'>
          <span className='text-xs font-bold'>
            {t('save_key')} {price?.discount} %
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default Pricing;
